<script setup>
import { stateManager } from '@/stateManager';
import Box from '../ui/Box.vue';
import { getFavoriteVersesByPsalm } from '@/libs/favorites';
import salmi from "@/assets/json/salmi.json";

const f = getFavoriteVersesByPsalm();
const boxes = [];
for(const [psalm_index, verses] of Object.entries(f)) {
  for(const [verse_index, text] of Object.entries(verses)) {
    boxes.push({
      title: `Versetto ${psalm_index}:${verse_index}`,
      text: text,
      link: `/s/${psalm_index}/v/${verse_index}`
    });
  }
}

const quoteIcon = `<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#111111"><g><rect fill="none" height="24" width="24"/><path d="M14.17,5L19,9.83V19H5V5L14.17,5L14.17,5 M14.17,3H5C3.9,3,3,3.9,3,5v14c0,1.1,0.9,2,2,2h14c1.1,0,2-0.9,2-2V9.83 c0-0.53-0.21-1.04-0.59-1.41l-4.83-4.83C15.21,3.21,14.7,3,14.17,3L14.17,3z M7,15h10v2H7V15z M7,11h10v2H7V11z M7,7h7v2H7V7z"/></g></svg>`
</script>

<template>
  <div class="elenco elenco-favorites" :class="[{ animationShow_v3_fast: stateManager.animationEnabled}]">
      <h2>Versetti ({{ boxes.length }})</h2>
      <div class="single-salmo">
        <Box 
          v-for="b in boxes"
          :title="b.title" :text="b.text" :link="b.link" :icon="quoteIcon" />
      </div>
    </div>
</template>